<template>
  <!--
    Code By     : 陈伦刚
    CreateTime  : 2020-12-14 01:36:00
    Description :
  -->
  <div class="main page">
    <span class="title">创作出售认证</span>
    <span>
      创作者在首次出售自己的创作内容前, 需再次核对身份及其他必需信息;
      请务必认真如实提交有效个人信息并保持更新!
    </span>
    <div class="box">
      <div class="left">
        <div class="item" style="margin-bottom: 20px">
          <span class="name" style="font-size: 16px; font-weight: bold"
            >认证用户类型:
          </span>
          <el-radio v-model="contentType" label="own">个人</el-radio>
          <el-radio v-model="contentType" label="institutions">机构</el-radio>
        </div>
        <div v-show="contentType == 'own'">
          <div class="item">
            <span class="name">真实姓名: </span>
            <el-input
              v-model="name"
              placeholder="请输入您的真实姓名"
              size="mini"
              style="width: 220px"
            ></el-input>
          </div>
          <div class="item">
            <span class="name">身份证号: </span>
            <el-input
              v-model="codeNumber"
              maxlength="18"
              placeholder="请输入您的身份证号码"
              size="mini"
              style="width: 220px"
            ></el-input>
          </div>
        </div>
        <div v-show="contentType == 'institutions'">
          <div class="item">
            <span class="name">机构全称: </span>
            <el-input
              v-model="institutionsName"
              placeholder="请输入机构全称"
              size="mini"
              style="width: 220px"
            ></el-input>
          </div>
          <div class="item">
            <span class="name" style="width: 64px; display: inline-block">
              联系人:
            </span>
            <el-input
              v-model="name"
              placeholder="请输入联系人姓名"
              size="mini"
              style="width: 220px"
            ></el-input>
          </div>
          <div class="item">
            <span class="name" style="width: 64px; display: inline-block">
              手机号:
            </span>
            <el-input
              v-model="phoneNumber"
              placeholder="请输入手机号"
              size="mini"
              style="width: 120px; margin-right: 7px"
            ></el-input>
            <el-button
              :disabled="time !== 0"
              :loading="sendCodeLoading"
              size="mini"
              type="primary"
              @click="sendCode"
            >
              {{ time === 0 ? "获取验证码" : `${time}s` }}
            </el-button>
          </div>
          <div class="item">
            <span class="name" style="width: 64px; display: inline-block">
              验证码:
            </span>
            <el-input
              v-model="code"
              placeholder="请输入验证码"
              size="mini"
              style="width: 220px"
            ></el-input>
          </div>
          <div class="item">
            <span class="name">证件类型: </span>
            <el-select
              v-model="certType"
              placeholder="请选择"
              size="mini"
              style="width: 220px"
            >
              <el-option
                v-for="item in [
                  {
                    value: 1,
                    label: '组织机构代码',
                  },
                  {
                    value: 2,
                    label: '企业营业执照号码',
                  },
                ]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <span class="name">证件号码: </span>
            <el-input
              v-model="institutionsCode"
              placeholder="请输入证件号码"
              size="mini"
              style="width: 220px"
            ></el-input>
          </div>
        </div>
        <div class="item">
          <span style="font-size: 12px; color: #999">
            ＊请正确填写您的证件号码，并在页面右侧上传清晰的<br />
            证件正反面照片； 证件照片格式.jpg，不大于5MB：
          </span>
        </div>
        <div class="item">
          <el-checkbox v-model="access"> 我接受 </el-checkbox>
          <a
            class="pact"
            href="https://gaiamount.com/desktop/richPage?type=2"
            target="_blank"
          >
            《Gaiamount销售协议》
          </a>
        </div>
        <div class="item">
          <el-button
            :loading="submitLoading"
            :disabled="!access"
            type="primary"
            style="width: 220px"
            size="small"
            @click="submit"
          >
            确认提交
          </el-button>
        </div>
      </div>
      <el-divider direction="vertical"></el-divider>
      <div class="right">
        <div class="item">
          <div class="name" style="margin-bottom: 6px">证件正面照:</div>
          <upload-cover
            title="上传"
            :src="fontPhoto"
            @change="fontPhotoChange"
          />
          <br />
          <div class="name" style="margin-bottom: 6px">证件背面照:</div>
          <upload-cover
            title="上传"
            :src="backPhoto"
            @change="backPhotoChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UploadCover from "@/components/upload/upload-cover";
import { verifiedUpload } from "@/api/material";
import { sendCode } from "@/api/account";
import { checkVerified } from "@/api/upload";
export default {
  components: {
    UploadCover,
  },
  data() {
    return {
      contentType: "own",
      name: "",
      codeNumber: "",
      access: false,
      fontPhoto: "",
      backPhoto: "",
      code: "",
      institutionsCode: "",
      institutionsName: "",
      name: "",
      phoneNumber: "",
      sendCodeLoading: false,
      submitLoading: false,
      time: 0,
      setInterval: null,
      certType: 1,
    };
  },
  created() {
    checkVerified()
      .then((res) => {
        console.log(res);
      })
      .catch((res) => {
        console.log(res);
      });
  },
  methods: {
    fontPhotoChange(e) {
      this.fontPhoto = e;
    },
    backPhotoChange(e) {
      this.backPhoto = e;
    },
    sendCode() {
      this.sendCodeLoading = true;
      sendCode({ account: this.phoneNumber, retry: false })
        .then((res) => {
          this.$message.success("短信发送成功");
          this.sendCodeLoading = false;
          this.time = 60;
          this.setInterval = setInterval(() => {
            this.time--;
            if (this.time === 0) {
              clearInterval(this.setInterval);
            }
          }, 1000);
        })
        .catch((res) => {
          this.$message.error("短信发送失败");
          console.log(res);
          this.sendCodeLoading = false;
        });
    },
    submit() {
      const data = {
        fontPhoto: this.fontPhoto,
        backPhoto: this.backPhoto,
        businessNo: this.businessNo,
        code: this.code,
        codeNumber: this.codeNumber,
        contentType: this.contentType,
        institutionsCode: this.institutionsCode,
        institutionsName: this.institutionsName,
        name: this.name,
        phoneNumber: this.phoneNumber,
      };
      if (this.fontPhoto == "" || this.backPhoto == "") {
        this.$message.warning("请上传证件照");
        return;
      }
      if (this.contentType == "own") {
        if (data.codeNumber == "" || data.name == "") {
          this.$message.warning("[1]请将信息填写完整");
          return;
        }
      } else {
        if (
          data.name == "" ||
          data.businessNo == "" ||
          data.code == "" ||
          data.institutionsCode == "" ||
          data.institutionsName == ""
        ) {
          this.$message.warning("[2]请将信息填写完整");
          return;
        }
      }
      this.submitLoading = true;
      verifiedUpload(data)
        .then((res) => {
          // code.expire
          console.log(res);
          this.$message.success("提交成功");
          this.submitLoading = false;
        })
        .catch((res) => {
          this.submitLoading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  padding-top: 100px;
}

.left,
.right {
  width: 48%;
}

.title {
  font-size: 28px;
  font-weight: bold;
  margin-right: 10px;
}

.box {
  display: flex;
  border: 1px solid #dcdcdc;
  margin-top: 20px;
  padding: 60px 50px;
}

.name {
  margin-right: 20px;
  font-size: 14px;
}

.item {
  margin: 20px 80px;
}

.pact {
  font-size: 12px;
  color: #ff464c;
  text-decoration: none;
}

.el-divider--vertical {
  height: 300px;
}
</style>
